import { store } from './store.js';

export var shared = {
    filters: {
        correctImgUrl: function (value) {
            if (value == undefined) {
                return value;
            }
            if (value.startsWith('~')) {
                value = value.substr(1);
            }

            return value;
        },
        roundNumber: function (value) {
            return value.toFixed(2);
        }
    },
    methods: {
      getLabel: function (key) {
        var label = store.getLabel(key);
        return label;
      },
      getCustomerLabel: function (key) {
        var label = store.getCustomerLabel(key);
        return label;
      }
    }
}